export default __webpack_public_path__ + "static/media/contract.fc1937db.svg";